import { render, staticRenderFns } from "./dateCountsTable.vue?vue&type=template&id=20c788aa&scoped=true&"
import script from "./dateCountsTable.vue?vue&type=script&lang=js&"
export * from "./dateCountsTable.vue?vue&type=script&lang=js&"
import style0 from "./dateCountsTable.vue?vue&type=style&index=0&id=20c788aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c788aa",
  null
  
)

export default component.exports